import { observer } from 'mobx-react';
import React from 'react';
import { when } from '@execonline-inc/maybe-adapter';
import ChevronDown from '../Cutesies/ChevronDown';
import { SortDirection } from '../../ListFilter/Types';

interface Props {
  sortKey: string;
  sortDirection: SortDirection;
  currentSortKey: string;
}

const isCurrentSort = (props: Props) => when(props.sortKey === props.currentSortKey, true);

const getSortDirection = (props: Props) => {
  switch (props.sortDirection) {
    case 'desc':
      return (
        <div className="ml-2 w-5">
          <ChevronDown />
        </div>
      );
    case 'asc':
      return (
        <div className="ml-2 w-5 rotate-180">
          <ChevronDown />
        </div>
      );
  }
};

const SortArrow: React.FC<Props> = (props) =>
  isCurrentSort(props)
    .map(() => getSortDirection(props))
    .getOrElse(() => <></>);

export default observer(SortArrow);
